module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.7@core-js/library/modules/_library.js
// module id = bgFz
// module chunks = 0